import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticationService, UserRole } from 'app/core/authentication';

@Injectable({
  providedIn: 'root'
})
export class DemoSiteGuard  {

  constructor(private readonly authService: AuthenticationService) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const claims = this.authService.getUserClaims();

    if (claims && claims.roles.includes(UserRole.demoSiteAdmin)) {
      return true
    }

    return false;
  }
}
